export const DEFAULT_PUSH_API_ORIGIN = "https://push-api.g1.network";
export const DEFAULT_THEME_COLOR = "#1a56db";
export const DEFAULT_BACKGROUND_COLOR = "#0b1220";
export function defaultIcons() {
    return [
        { src: "/icon-192.png", sizes: "192x192", type: "image/png" },
        { src: "/icon-512.png", sizes: "512x512", type: "image/png" },
        { src: "/icon-512.png", sizes: "512x512", type: "image/png", purpose: "maskable" },
    ];
}
//# sourceMappingURL=types.js.map